import { render } from "./DateSelector.vue?vue&type=template&id=2e15478c&scoped=true"
import script from "./DateSelector.vue?vue&type=script&lang=js"
export * from "./DateSelector.vue?vue&type=script&lang=js"

import "./DateSelector.vue?vue&type=style&index=0&id=2e15478c&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e15478c"]])

export default __exports__